import { type ReactNode } from 'react';
import { FeedCard } from '@/components/comunicados/feed-card';
import type { FeedItem } from '@/components/comunicados/types';
import { useAuth } from '@/hooks/use-auth';
import { useMarkRead } from '../hooks/use-mark-read';
import { fmtRelative } from '../utils/format';
import { FeedAdminActions } from './feed-admin-actions';

type Props = { item: FeedItem };

export function FeedItemCard({ item }: Props): ReactNode {
  const ref = useMarkRead(item.id, !!item.is_read);
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';
  return (
    <FeedCard
      item={item}
      showUnreadDot={!item.is_read}
      timestamp={fmtRelative(item.published_at || item.created)}
      actions={isAdmin ? <FeedAdminActions id={item.id} /> : undefined}
      headerRef={ref}
    />
  );
}
